import {
  AssistantFunnelEventInput,
  postStaffAssistantEvents
} from "../../api/staff-agent"

/**
 * Assistant workflow-funnel tracker. Events queue locally and flush in
 * batches (interval, size cap, or page-hide) to POST /api/events on the
 * agent service, which stamps identity server-side and records them into
 * the same telemetry stream as server-side outcomes. Tracking must never
 * affect the product: failures are swallowed and the queue is dropped
 * rather than retried into a backlog.
 */
const FLUSH_INTERVAL_MS = 5_000
const MAX_QUEUE = 20

let queue: AssistantFunnelEventInput[] = []
let flushTimer: number | null = null

export function trackAssistantEvent(
  event: string,
  fields?: Record<string, string | number | boolean>
): void {
  queue.push(fields ? { event, fields } : { event })
  if (queue.length >= MAX_QUEUE) {
    void flushAssistantEvents()
  } else if (flushTimer === null) {
    flushTimer = window.setTimeout(
      () => void flushAssistantEvents(),
      FLUSH_INTERVAL_MS
    )
  }
}

export async function flushAssistantEvents(): Promise<void> {
  if (flushTimer !== null) {
    window.clearTimeout(flushTimer)
    flushTimer = null
  }
  if (queue.length === 0) return
  const batch = queue
  queue = []
  try {
    await postStaffAssistantEvents(batch)
  } catch {
    // Telemetry is best-effort by design — never surface or retry.
  }
}

// Final best-effort flush when the tab hides or unloads (keepalive fetch).
if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") void flushAssistantEvents()
  })
}
